<template>
  <section class="sec-produce-page background-sec">
    <div class="produce-page">
      <div class="sec-titr">
        <h1 class="sec-titr__title">عسل چگونه تولید می شود ؟</h1>
      </div>
      <div class="produce-page-text-1 produce-page-text">
        <p>
          برای یک زنبوردار و یا کسی که با کار زنبورداری از نزدیک آشنا بوده است،
          قطعا پاسخ به این سوال که عسل چگونه تولید می شود و آیا عسل مدفوع زنبور
          عسل است یا خیر بسیار ساده است. اما اگر شما هم از جمله کسانی هستید که
          صرفا مصرف کننده عسل بوده‌اید، قطعا این دغدغه و سوال برایتان پیش آمده
          است که بالاخره عسل از کجای زنبور تولید می‌شود؟ یک نفر می‌گوید عسل
          مدفوع زنبور عسل است یک نفر می‌گوید نه بزاق زنبور است و خلاصه هر کسی
          چیزی می‌گوید. در این مطلب قصد داریم تا به این پرسش‌ها پاسخ‌هایی تا حد
          ممکن ساده بدهیم.
        </p>
      </div>
      <div class="produce-page-title-1 produce-page-title">
        <h2>آیا عسل مدفوع زنبور عسل است؟</h2>
      </div>
      <div class="produce-page-text-2 produce-page-text">
        <p>
          جواب به این سوال همانقدر ساده است که بگویم آیا شیر، ادرار گاو یا
          گوسفند است! قطعا هیچ موجودی حاضر نیست که مدفوع خود را با این همه زحمت
          ذخیره سازی کند. اولین نکته‌ای که باید بدانیم این است که عسل نه مدفوع
          زنبور عسل است و نه بذاق دهان زنبور. بلکه غذایی است که زنبور آن را در
          فصل‌های گرم سال، از شهد گل‌ها و گیاهان حاصل می‌کند تا در فصل‌های سرد
          سال از آن تغذیه کند. کار زنبوردار این است که با کوچ دادن زنبور به
          جاهای مختلف، کاری کند که زنبور، مقدار عسل بیشتری تولید کند تا ما هم
          بتوانیم از آن استفاده کنیم.
        </p>
      </div>
      <div class="produce-page-title-2 produce-page-title">
        <h2>آیا زنبور عسل هم مدفوع دارد؟</h2>
      </div>
      <div class="produce-page-text-3 produce-page-text">
        <p>
          بله قطعا، زنبور هم دارای یک سیستم گوارش است که از عسل و گرده گل برای
          زنده ماندن تغدیه می‌کند و مانند هر موجود دیگری که داری سیستم گوارش است
          مدفوع هم دارد. اما این مدفوع کاملا با عسل متفاوت است. ضمن اینکه زنبور
          عسل به هیچ وجه مدفوع خود را داخل کندو نمی‌ریزد چرا که می‌توان گفت
          زنبور عسل یکی از پاکیزه ترین موجوادت جهان است که نسبت به هر گونه
          آلودگی حتی ذرات گرد و غبار نیز حساس است. زنبور عسل مدفوع خود را در
          پروازهایی که به بیرون دارد در بیرون از کندو تخلیه می‌کند. حتی گاهی در
          فصل‌های سرد که دمای هواز زیر ۱۰ درجه است و زنبور قادر به بیرون رفتن و
          پرواز نیست. ممکن است دو تا سه هفته و یا حتی بیشتر مدفوع خود را نگه
          دارد تا زمانی که شرایط مساعد برای پرواز به بیرون پیش بیاید و آنگاه
          مدفوع خود را خارج می‌کند. (+) مدفوع زنبور عسل بسته به نوع تغذیه و
          سلامت آن رنگ‌های مختلفی دارد اما معمولا آجری شکل است و برعکس تمام
          تولیدات زنبور هیچگونه خاصیتی هم ندارد. برخی از نمونه های مدفوع زنبور
          عسل البته گاهی پیش می‌آید که زنبور به خاطر برخی از بیماری‌ها و یا
          اختلال در سیستم گوارش خود در داخل کندو مدفوع کند، که آن هم به سرعت از
          داخل کندو خارج می‌شود اما در حالت عادی زنبور این کار را انجام نمی‌دهد.
        </p>
      </div>
      <div class="produce-page-title-3 produce-page-title">
        <h2>عسل چگونه تولید می شود و از کجای زنبور است؟</h2>
      </div>
      <div class="produce-page-text-4 produce-page-text">
        <p>
          تا اینجای کار متوجه شدیم که عسل قطعا مدفوع زنبورعسل نیست و زنبور حتی
          در شرایطی که نمی‌تواند پرواز کند هم مدفوع خود را تا هفته‌ها نگه
          می‌دارد که آلودگی وارد کندو نشود و آن را در خارج از کندو تخلیه می‌کند.
          اما حالا این سوال به وجود می‌آید که پس عسل چیست و چگونه تولید می‌شود و
          از کجای زنبور خارج می‌شود. تولید عسل چندین مرحله دارد که شامل: ۱. جمع
          آوری شهد ۲. تغلیظ شهد ۳. ذخیره سازی و پلمپ است. که در زیر در مورد آنها
          صحبت می‌کنیم
        </p>
      </div>
      <div class="produce-page-title-4 produce-page-title">
        <h2>مراحل تولید عسل طبیعی توسط زنبور</h2>
      </div>
      <div class="produce-page-text-5 produce-page-text">
        <h4>مرحله اول: جمع آوری شهد</h4>
        <p>
          در این مرحله زنبوران کارگر در صورتی که شرایط آب و هوایی مساعد باشد و
          منطقه نیز دارای شهد باشد (ممکن است این شهد حاصل گل‌ها باشد یا شیره‌ی
          بعضی از درختان) از کندو خارج شده و به سمت منابع شهد پرواز می‌کنند. این
          پروازها گاهی حتی تا ۵ کیلومتر هم ادامه دارد. سپس زنبور بر روی گل یا
          گیاه مورد نظر می‌نشیند و با خرطوم خود شهد آن را می‌مکد و در عسلدان خود
          که قبل از معده‌اش قرار دارد ذخیره می‌کند. زنبور عسل در هر پرواز حدود
          ۴۰ میلی گرم شهد با خود به همراه می‌آورد. در طول مسیر اگر زنبور به
          انرژی نیاز داشته باشد کافی است تا دریچه بین عسلدان و معده را باز کند
          تا از شهد تغذیه کند. البته زنبور عسل علاوه بر عسل برای زنده ماندن به
          پروتئین هم نیاز دارد که این پروتئین را ازگرده‌هایی که به بدن و پاهایش
          می‌چسبد و عامل گرده افشانی گیاهان نیز هستند تامین می‌کند و آن را نیز
          با خود به درون کندو حمل می‌کند. پس زنبور با حدود ۴۰ میلی‌گرم شهد که در
          عسل‌دان خود ذخیره کرده است به سمت کندو پرواز می‌کند. این شهد با عسل
          کاملا متفاوت است و حاوی ۴۰ تا ۸۰ درصد آب است. در حین پرواز، زنبور
          مقداری از این آب را جذب می‌کند و سپس آن را درون حجره‌های شش ضلعی تخلیه
          می‌کند
        </p>
        <h4>مرحله دوم: تغلیظ شهد جمع آوری شده</h4>
        <p>
          این همان مرحله‌ای است که شهد گل‌ها به عسل، این ماده لذیذ تبدیل می‌شود.
          در این مرحله زنبوران کارگر بارها و بارها شهد‌های موجود در حجره‌ها را
          با خرطوم خود دوباره به عسلدان می‌برند و مقداری از آب آن را جذب می‌کند
          و در حین این فرآیند آنزیم های عسل و همچنین مواد ضد باکتریایی و اسیدهای
          آمینه مثل پرولین را وارد شهد می‌کنند. این فرآیند یعنی مکیدن شهد و
          تغلیظ کردن آن و دوباره برگرداندن آن به حجره‌ها تا زمانی ادامه پیدا
          می‌کند که غلظت آب درون شهد به ۲۰ درصد برسد اینجاست که می‌توان نام عسل
          را بر محصول نهایی گذاشت. البته عسل در این مرحله هنوز قابل برداشت نیست
          و یک مرحله دیگر مانده است.
        </p>
      <h4>مرحله سوم: تکمیل فرآیند و پلمپ حجره‌ها</h4>
      <p>
        زنبورهای عسل بعد از این که تا حد ممکن شهد را غلیظ کردند با بال زدن‌های
        سریع و هماهنگ خود باعث می‌شوند که رطوبت عسل باز هم کمتر شود و زمانی که
        مطمئن شدند که عسل به غلظت مناسب رسیده است بر روی حجره‌ها پولک می‌زنند و
        اصطلاحا آن را پلمپ می‌کنند و آن را ذخیره می‌کنند. ذخیره و پلمپ حجره‌ها
        توسط زنبور عسل شاید از خود بپرسید که زنبور چرا این همه فرآیند را بر روی
        شهد انجام می‌دهد و همان شهد را مصرف نمی‌کند. علت آن این است که زنبور به
        دنبال یک منبع مقوی و در عین‌ حال کم حجم است. به همین دلیل است که رطوبت
        عسل را کاهش می‌دهد تا کم حجم شود. همچنین آنزیم دیاستاز را وارد شهد
        می‌کند تا ساکارز موجود در عسل را به قند‌های ساده تری مثل فرکتوز و گلوکز
        تبدیل کند چرا که حلالیت این دو قند در آب به مراتب از ساکارز بیشتر است و
        در نتیجه محصول نهایی سرشار از کربوهیدرات است. ضمن این که زنبور عسل با
        وارد کردن مواد ضد باکتریایی و کاهش رطوب عسل کاری می‌کند که عسل برای
        طولانی مدت فاسد نشود. و به همین دلیل است که برخی می‌گویند عسل تاریخ
        انقضا ندارد و فاسد نمی‌شود چرا که عامل اصلی رشد باکتری‌ها که باعث تخمیر
        عسل می‌شود رطوبت است و زنبورها با پایین نگه داشتن رطوبت عسل از این کار
        جلوگیری می‌کنند پس از پولک گذاری کامل یک شان (قاب‌های کندو) عسل اصطلاحا
        رسیده است و آماده‌ی برداشت است و زنبوردار در این مرحله عسل را استخراج
        می‌کند.
      </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style></style>
